<div class="max-w-5xl">
  <form #profileForm="ngForm" (ngSubmit)="saveProfile(profileForm)" class="space-y-4" novalidate>

    <!-- First Name -->
    <div class="grid grid-cols-[220px_1fr] items-center gap-4">
      <label class="text-sm font-medium text-slate-700">First Name</label>

      <div class="w-full">
        <input
          type="text"
          class="input input-bordered w-full"
          [(ngModel)]="profile.first_name"
          name="first_name"
          #firstName="ngModel"
          required
          minlength="2"
          maxlength="50"
          pattern="[a-zA-Z\s]+"
        >
        @if (firstName.invalid && firstName.touched) {
          <p class="text-xs text-error mt-1">
            @if (firstName.errors?.['required']) { First Name is required. }
            @if (firstName.errors?.['minlength']) { First Name must be between 2 and 50 characters. }
            @if (firstName.errors?.['maxlength']) { First Name must not exceed 50 characters. }
            @if (firstName.errors?.['pattern']) { First Name must contain letters only. }
          </p>
        }
      </div>
    </div>

    <!-- Middle Name -->
    <div class="grid grid-cols-[220px_1fr] items-center gap-4">
      <label class="text-sm font-medium text-slate-700">
        Middle Name (Optional)
      </label>

      <div class="w-full">
        <input
          type="text"
          max="50"
          class="input input-bordered w-full"
          [(ngModel)]="profile.middle_name"
          name="middle_name"
          #middleName="ngModel"
          maxlength="50"
          pattern="[a-zA-Z\s]*"
        >
        @if (middleName.invalid && middleName.touched) {
          <p class="text-xs text-error mt-1">
            @if (middleName.errors?.['maxlength']) { Middle Name must not exceed 50 characters. }
            @if (middleName.errors?.['pattern']) { Middle Name must contain letters only. }
          </p>
        }
      </div>
    </div>

    <!-- Last Name -->
    <div class="grid grid-cols-[220px_1fr] items-center gap-4">
      <label class="text-sm font-medium text-slate-700">Last Name</label>

      <div class="w-full">
        <input
          type="text"
          max="50"
          class="input input-bordered w-full"
          [(ngModel)]="profile.last_name"
          name="last_name"
          #lastName="ngModel"
          required
          minlength="2"
          maxlength="50"
          pattern="[a-zA-Z\s]+"
        >
        @if (lastName.invalid && lastName.touched) {
          <p class="text-xs text-error mt-1">
            @if (lastName.errors?.['required']) { Last Name is required. }
            @if (lastName.errors?.['minlength']) { Last Name must be between 2 and 50 characters. }
            @if (lastName.errors?.['maxlength']) { Last Name must not exceed 50 characters. }
            @if (lastName.errors?.['pattern']) { Last Name must contain letters only. }
          </p>
        }
      </div>
    </div>

<!-- Email -->
<div class="grid grid-cols-[140px_80px_1fr] gap-2 items-center">
  <label class="text-sm  font-medium text-slate-700">
    Email
  </label>

  <span class="px-2 py-1 font-bold text-xs bg-zinc-200 text-center rounded">
    Personal
  </span>

  <div>
    <input
      type="email"
      email
      maxlength="100"
      class="input input-bordered w-full"
      [(ngModel)]="profile.email"
      name="primaryEmail"
      #primaryEmail="ngModel"
      required
      readonly>
    @if (primaryEmail.invalid && primaryEmail.touched) {
      <p class="text-xs text-error mt-1">
        @if (primaryEmail.errors?.['required']) { Email is required. }
        @if (primaryEmail.errors?.['email']) { Please enter a valid email address. }
        @if (primaryEmail.errors?.['maxlength']) { Email must not exceed 100 characters. }
      </p>
    }
  </div>
</div>

<div class="grid grid-cols-[140px_80px_1fr] gap-2 items-center mt-3">
  <div></div>

  <span class="px-2 font-bold py-1 text-xs bg-zinc-200 text-center rounded">
    Work
  </span>

  <div>
    <input
      type="email"
      email
      maxlength="100"
      class="input input-bordered w-full"
      [(ngModel)]="profile.secondary_email"
      name="secondaryEmail"
      #secondaryEmail="ngModel">
    @if (secondaryEmail.invalid && secondaryEmail.touched) {
      <p class="text-xs text-error mt-1">
        @if (secondaryEmail.errors?.['email']) { Please enter a valid email address. }
        @if (secondaryEmail.errors?.['maxlength']) { Alternate Email must not exceed 100 characters. }
      </p>
    }
  </div>
</div>

<!-- Mobile -->
<div class="grid grid-cols-[140px_80px_1fr] gap-2 items-center mt-4">
  <label class="text-sm font-medium text-slate-700">
    Mobile No.
  </label>

  <span class="px-2 font-bold py-1 text-xs bg-zinc-200 text-center rounded">
    Personal
  </span>

  <div>
    <input
      type="tel"
      class="input input-bordered w-full"
      [(ngModel)]="profile.mobile"
      name="primaryMobile"
      #primaryMobile="ngModel"
      required
      pattern="[0-9]{10}"
      maxlength="10"
      readonly>
    @if (primaryMobile.invalid && primaryMobile.touched) {
      <p class="text-xs text-error mt-1">
        @if (primaryMobile.errors?.['required']) { Mobile is required. }
        @if (primaryMobile.errors?.['pattern']) { Mobile number must be exactly 10 digits. }
      </p>
    }
  </div>
</div>

<div class="grid grid-cols-[140px_80px_1fr] gap-2 items-center mt-3">
  <div></div>

  <span class="px-2 font-bold py-1 text-xs bg-zinc-200 text-center rounded">
    Work
  </span>

  <div>
    <input
      type="tel"
      class="input input-bordered w-full"
      [(ngModel)]="profile.secondary_mobile"
      name="secondaryMobile"
      #secondaryMobile="ngModel"
      pattern="[0-9]{10}"
      maxlength="10">
    @if (secondaryMobile.invalid && secondaryMobile.touched) {
      <p class="text-xs text-error mt-1">
        @if (secondaryMobile.errors?.['pattern']) { Mobile number must be exactly 10 digits. }
      </p>
    }
  </div>
</div>

    <!-- Password -->
    <div class="grid grid-cols-[220px_1fr] items-center gap-4">
      <label class="text-sm font-medium text-slate-700">
        Password
      </label>

      <div class="relative">

        <input
          type="password"
          class="input input-bordered w-full pr-12 cursor-pointer"
          readonly
          (click)="openPasswordModal()"
          placeholder="Click to change password"
        >

      </div>
    </div>

    <!-- Save Button -->
   <div class="flex justify-end gap-3 mt-8">
  <button
    type="submit"
    class="btn btn-primary"
    [disabled]="isSaving">

    <span *ngIf="isSaving" class="loading loading-spinner loading-sm"></span>

    {{ isSaving ? 'Saving...' : 'Save Profile' }}
  </button>
</div>

  </form>
</div>

<!-- Password Change Modal -->
<div
  class="modal"
  [class.modal-open]="isPasswordModalOpen"
  (click)="closePasswordModal()">

  <div
    class="modal-box"
    (click)="$event.stopPropagation()">

    <h3 class="font-bold text-lg">
      Change Password
    </h3>

    <div class="py-4">

      <!-- New Password -->
      <div class="form-control">

        <label class="label">
          <span class="label-text">
            New Password
          </span>
        </label>

        <div class="relative">
          <input
            [type]="showNewPassword ? 'text' : 'password'"
            placeholder="Enter new password"
            class="input input-bordered w-full pr-12"
            [(ngModel)]="newPassword"
            name="newPassword"
            #newPasswordCtrl="ngModel"
            required
            minlength="8"
            maxlength="50"
            (input)="newPassword = newPassword.trim()"
          >
          <button
            type="button"
            class="absolute right-2 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center text-slate-500 hover:text-slate-800"
            (pointerdown)="toggleNewPasswordVisibility($event)"
            (click)="$event.preventDefault(); $event.stopPropagation()"
            [attr.aria-label]="showNewPassword ? 'Hide password' : 'Show password'"
            [title]="showNewPassword ? 'Hide password' : 'Show password'">
            <i class="text-lg" [ngClass]="showNewPassword ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
          </button>
        </div>

        @if (newPasswordCtrl.invalid && newPasswordCtrl.touched) {
          <div class="text-error text-xs mt-1 space-y-1">
            @if (newPasswordCtrl.errors?.['required']) { <p>New Password is required.</p> }
            @if (newPasswordCtrl.errors?.['minlength']) { <p>New Password must be at least 8 characters.</p> }
            @if (newPasswordCtrl.errors?.['maxlength']) { <p>New Password must not exceed 50 characters.</p> }
            @if (newPasswordCtrl.errors?.['uppercase']) { <p>Password must contain at least one uppercase letter.</p> }
            @if (newPasswordCtrl.errors?.['lowercase']) { <p>Password must contain at least one lowercase letter.</p> }
            @if (newPasswordCtrl.errors?.['number']) { <p>Password must contain at least one number.</p> }
            @if (newPasswordCtrl.errors?.['specialChar']) { <p>Password must contain at least one special character.</p> }
            @if (newPasswordCtrl.errors?.['onlySpaces']) { <p>Password cannot contain only spaces.</p> }
          </div>
        }

      </div>

      <!-- Confirm Password -->
      <div class="form-control mt-4">

        <label class="label">
          <span class="label-text">
            Confirm Password
          </span>
        </label>

        <div class="relative">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            placeholder="Confirm new password"
            class="input input-bordered w-full pr-12"
            [(ngModel)]="confirmPassword"
            name="confirmPassword"
            #confirmPasswordCtrl="ngModel"
            required
            (input)="confirmPassword = confirmPassword.trim()"
          >
          <button
            type="button"
            class="absolute right-2 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center text-slate-500 hover:text-slate-800"
            (pointerdown)="toggleConfirmPasswordVisibility($event)"
            (click)="$event.preventDefault(); $event.stopPropagation()"
            [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'"
            [title]="showConfirmPassword ? 'Hide password' : 'Show password'">
            <i class="text-lg" [ngClass]="showConfirmPassword ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
          </button>
        </div>

        @if (confirmPasswordCtrl.invalid && confirmPasswordCtrl.touched) {
          <div class="text-error text-xs mt-1 space-y-1">
            @if (confirmPasswordCtrl.errors?.['required']) { <p>Confirm Password is required.</p> }
            @if (confirmPasswordCtrl.errors?.['passwordMismatch']) { <p>Confirm Password must match New Password.</p> }
          </div>
        }

      </div>

    </div>

    <!-- Modal Actions -->
    <div class="modal-action">

      <button
        class="btn"
        (click)="closePasswordModal()">

        Cancel

      </button>

      <button
        class="btn btn-primary"
        (click)="changePassword()">

        Change Password

      </button>

    </div>

  </div>
</div>
